import { createPinia, Pinia } from 'pinia'

let piniaInstance: Pinia | null

// Reset the Pinia instance when Turbolinks navigates to a new page
window.addEventListener('turbolinks:before-visit', () => {
  piniaInstance = null
})

const setupPiniaInstance = (): Pinia => {
  piniaInstance = createPinia()
  return piniaInstance
}

const getPiniaInstance = (): Pinia => {
  return piniaInstance ? piniaInstance : setupPiniaInstance()
}

export default getPiniaInstance
